import { AbstractMedia } from 'types/AbstractMedia';

export enum GateType {
  PIN_CODE = 'PIN_CODE',
  QR_CODE = 'QR_CODE',
  RELAY = 'RELAY',
}

export interface GateConfig {
  type: GateType;
  pinCode?: string;
  qrCode?: AbstractMedia;
}

export interface Gate {
  id: string;
  config: GateConfig;
}
